import { render, staticRenderFns } from "./ProductCatalogIcon.vue?vue&type=template&id=26185194&scoped=true"
import script from "./ProductCatalogIcon.vue?vue&type=script&lang=ts"
export * from "./ProductCatalogIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26185194",
  null
  
)

export default component.exports